import AttachmentPartPurchaseQualityControl from '@/models/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControl';

export default class AttachmentPartPurchaseQualityControlFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partPurchaseQcDetailId  = '';
		this.partPurchaseQcDetailControlCard = '';
		this.evidenceId  = '';
		this.evidenceOriginalFilename = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partPurchaseQcDetailId : '0',
			partPurchaseQcDetailControlCard : '0',
			evidenceId : '0',
			evidenceOriginalFilename : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}